import React, { useEffect, useState } from "react";
import "./ResidentProfile.css";

export default function ResidentProfile() {
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState("");

  const API = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(`${API}/api/auth/me`, {
          headers: { Authorization: `Bearer ${localStorage.getItem("residentToken")}` },
        });
        if (!res.ok) {
          setError("Failed to load your profile");
          return;
        }
        setProfile(await res.json());
      } catch (err) {
        setError("Server error while loading profile");
      }
    };
    load();
  }, [API]);

  return (
    <div className="resident-layout">
      
      <div className="resident-content">
        <h1 className="profile-title">My Profile</h1>

        {error && <p className="profile-error">{error}</p>}

        {profile && (
          <div className="profile-card">
            <div className="profile-row"><span>Name</span><strong>{profile.name}</strong></div>
            <div className="profile-row"><span>Email</span><strong>{profile.email}</strong></div>
            <div className="profile-row"><span>Phone</span><strong>{profile.phone || "Not provided"}</strong></div>
            <div className="profile-row"><span>Owner / Tenant</span><strong>{profile.residentType || "—"}</strong></div>
            <div className="profile-row"><span>Tower</span><strong>{profile.tower || "—"}</strong></div>
            <div className="profile-row"><span>Unit Type</span><strong>{profile.unitType || "—"}</strong></div>
            <div className="profile-row"><span>Floor</span><strong>{profile.floor || "—"}</strong></div>
            <div className="profile-row"><span>Unit Number</span><strong>{profile.unitNumber}</strong></div>
            <div className="profile-row"><span>Status</span><strong className="profile-status">{profile.status}</strong></div>
          </div>
        )}
      </div>
    </div>
  );
}